import { useEffect, useState } from 'react';
import { Incident } from '../types';

type GlobalIncident = {
  name: string;
  body: string;
  status: string;
  shortlink: string;
  iconApp?: string;
};

const useGlobalIncidents = () => {
  const [data, setData] = useState<Incident[]>();

  useEffect(() => {
    let isMounted = true;

    fetch('https://zapier.com/api/v3/support/incidents')
      .then(res => res.json())
      .then(({ objects }) => {
        if (isMounted && Array.isArray(objects) && objects.length > 0) {
          setData(
            (objects as GlobalIncident[]).map(incident => ({
              ...incident,
              iconApp: null,
            }))
          );
        }
      });

    return () => {
      isMounted = false;
    };
  }, []);

  return {
    data,
  };
};

export default useGlobalIncidents;
